<template>
  <Card class="m-3">
    <template #title="">Error 404</template>
    <template #content="">ไม่พบหน้าจอที่คุณระบุ </template>
    <template #footer="">
      <Button label="ย้อนกลับ" @click="onBack"></Button>
    </template>
  </Card>
</template>

<script lang="ts">
import { usePlugin } from "@/plugins";
import { defineComponent } from "vue";
export default defineComponent({
  name: "NotFound",
  setup() {
    const { router } = usePlugin();
    const onBack = () => {
      router.back();
    };
    return { onBack };
  },
});
</script>

<style></style>
